import { Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { strReplaceUrl } from '@utils/index';

interface ITagsProps {
  data: { name: string; url: string }[];
  useUrlInnerLink?: boolean; // 통합검색 내부 링크인지 / 외부 링크인지 여부
  useSharpTag?: boolean;
}

const setTagUrl = (url: string) => {
  const decodeUrl = decodeURIComponent(url);
  return encodeURI(strReplaceUrl(decodeUrl));
};

const Tags = ({ data, useUrlInnerLink, useSharpTag }: ITagsProps) => {
  return Array.isArray(data) && data?.length > 0 ? (
    <ul className="search-item-tags">
      {data?.map((v, i) => (
        <li key={i} className="tag-item">
          {useUrlInnerLink ? (
            <NavLink to={setTagUrl(v?.url)} className="tag">
              {useSharpTag ? '#' : ''}
              {v?.name}
            </NavLink>
          ) : (
            <a href={setTagUrl(v?.url)} className="tag" dangerouslySetInnerHTML={{ __html: `${useSharpTag ? '#' : ''}${v?.name}` }}></a>
          )}
        </li>
      ))}
    </ul>
  ) : (
    <Fragment />
  );
};

export default Tags;
